const dashboard = {
  // Page title
  title: 'Dashboard',
  welcomeBack: 'Welcome back',

  // Navigation tabs
  tabs: {
    overview: 'Overview',
    properties: 'Properties',
    analytics: 'Analytics',
    team: 'Team',
    settings: 'Settings',
  },

  // Overview section
  overview: {
    title: 'Overview',
    totalViews: 'Total Views',
    totalClicks: 'Total Clicks',
    totalContacts: 'Total Contacts',
    totalSaves: 'Total Saves',
    conversionRate: 'Conversion Rate',
    activeListings: 'Active Listings',
    pendingListings: 'Pending Listings',
    expiredListings: 'Expired Listings',
    recentActivity: 'Recent Activity',
    quickActions: 'Quick Actions',
  },

  // Stats
  stats: {
    views: 'Views',
    clicks: 'Clicks',
    contacts: 'Contacts',
    saves: 'Saves',
    listings: 'Listings',
    leads: 'Leads',
    revenue: 'Revenue',
    trend: {
      up: 'Increase',
      down: 'Decrease',
      fromLastPeriod: 'from last period',
    },
  },

  // Date range
  dateRange: {
    label: 'Date Range',
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    lastYear: 'Last year',
    allTime: 'All time',
    custom: 'Custom range',
    startDate: 'Start date',
    endDate: 'End date',
    apply: 'Apply',
  },

  // Analytics section
  analytics: {
    title: 'Analytics',
    performanceOverTime: 'Performance Over Time',
    topProperties: 'Top Performing Properties',
    viewsChart: 'Views Chart',
    clicksChart: 'Clicks Chart',
    contactsChart: 'Contacts Chart',
    heatmap: 'Heatmap',
    heatmapDescription: 'Best viewing times',
    marketComparison: 'Market Comparison',
    yourPerformance: 'Your Performance',
    marketAverage: 'Market Average',
    percentile: 'Percentile',
    aboveAverage: 'Above average',
    belowAverage: 'Below average',
    // Called without a key before, so the key itself showed (DashboardAnalytics).
    metricsDistribution: 'Metrics Distribution',
  },

  // Shared dashboard buttons (ExportModal calls common.cancel).
  common: {
    cancel: 'Cancel',
  },

  // Properties section
  properties: {
    title: 'Properties',
    allProperties: 'All Properties',
    activeProperties: 'Active Properties',
    pendingProperties: 'Pending Properties',
    expiredProperties: 'Expired Properties',
    addProperty: 'Add Property',
    editProperty: 'Edit Property',
    viewProperty: 'View Property',
    deleteProperty: 'Delete Property',
    renewProperty: 'Renew Listing',
    boostProperty: 'Boost Listing',
    noProperties: 'No properties',
    noPropertiesDescription: 'Start by adding your first property',
  },

  // Team section
  team: {
    title: 'Team Management',
    subtitle: '{{count}} team members',
    members: 'Team Members',
    inviteMember: 'Invite Member',
    inviteDescription: 'Send an invitation to join your team',
    pendingInvites: 'Pending Invites',
    you: 'You',
    joined: 'Joined',
    role: 'Role',
    roles: {
      owner: 'Owner',
      admin: 'Admin',
      agent: 'Agent',
      editor: 'Editor',
      viewer: 'Viewer',
    },
    roleDescriptions: {
      owner: 'Full access to all features',
      admin: 'Can manage team and listings',
      agent: 'Can manage listings and view analytics',
      viewer: 'View-only access',
    },
    rolesLegend: 'Role Permissions',
    status: {
      active: 'Active',
      pending: 'Pending',
      suspended: 'Suspended',
    },
    filters: {
      all: 'All Members',
      active: 'Active',
      pending: 'Pending',
    },
    permissions: {
      listings: 'Listings',
      analytics: 'Analytics',
      team: 'Team',
      subscription: 'Subscription',
    },
    fields: {
      email: 'Email Address',
      name: 'Full Name',
      role: 'Role',
      permissions: 'Permissions',
    },
    placeholders: {
      email: 'Enter email address',
      name: 'Enter full name',
    },
    errors: {
      emailRequired: 'Email is required',
      invalidEmail: 'Please enter a valid email',
      emailExists: 'This email is already in the team',
      nameRequired: 'Name is required',
      inviteFailed: 'Failed to send invitation',
    },
    lastActive: 'Last Active',
    remove: 'Remove',
    cancelInvite: 'Cancel Invite',
    resendInvite: 'Resend Invite',
    sendInvite: 'Send Invitation',
    sending: 'Sending...',
    inviteResent: 'Invitation resent to {{email}}',
    confirmRemove: 'Are you sure you want to remove {{name}} from the team?',
    searchPlaceholder: 'Search members...',
    noMembers: 'No team members',
    noMembersDescription: 'Invite your team members to collaborate',
    noResults: 'No members found',
    noResultsDescription: 'Try adjusting your search',
    inviteFirst: 'Invite First Member',
  },

  // Export
  export: {
    title: 'Export Reports',
    subtitle: 'Download your analytics data',
    selectFormat: 'Select Format',
    pdf: 'PDF',
    excel: 'Excel',
    csv: 'CSV',
    pdfDescription: 'Formatted report with charts',
    excelDescription: 'Spreadsheet with all data',
    csvDescription: 'Raw data for import',
    selectDateRange: 'Select Date Range',
    dateRange: 'Date Range',
    last30Days: 'Last 30 days',
    selectMetrics: 'Select Metrics',
    allMetrics: 'All Metrics',
    includes: "What's Included",
    includesSummary: 'Performance summary',
    includesTimeSeries: 'Daily data breakdown',
    includesProperties: 'Property-level metrics',
    download: 'Download',
    exporting: 'Exporting...',
    success: 'Report downloaded successfully',
    error: 'Failed to download report',
  },

  // Contact info
  contactInfo: {
    title: 'Contact Information',
    businessName: 'Business Name',
    phone: 'Phone Number',
    email: 'Email',
    whatsapp: 'WhatsApp',
    workingHours: 'Working Hours',
    autoReply: 'Auto Reply',
    autoReplyMessage: 'Auto Reply Message',
    save: 'Save Changes',
    saved: 'Changes saved',
  },

  // Subscription info
  subscription: {
    title: 'Subscription',
    currentPlan: 'Current Plan',
    listingsUsed: 'Listings Used',
    renewalDate: 'Renewal Date',
    daysRemaining: 'Days Remaining',
    upgrade: 'Upgrade Plan',
    manage: 'Manage Subscription',
    expired: 'Expired',
    expiresIn: 'Expires in',
  },

  // Empty states
  emptyStates: {
    noData: 'No data',
    noDataDescription: 'No data available for this period',
    noActivity: 'No activity',
    noActivityDescription: 'No activity recorded yet',
  },

  // Loading
  loading: 'Loading...',
  refreshing: 'Refreshing...',
  lastUpdated: 'Last updated',

  // Company Dashboard specific translations
  company: {
    title: 'Company Dashboard',
    subtitle: 'Overview of your company',
    propertyUsage: 'Property Usage',

    kpiCards: {
      active: 'Active',
      pending: 'Pending',
      team: 'Team',
    },

    quickActions: {
      title: 'Quick Actions',
      properties: 'Properties',
      team: 'Team',
      settings: 'Settings',
    },

    agentBreakdown: {
      title: 'Listings by Agent',
      listings: 'listings',
    },

    recentActivity: {
      title: 'Recent Activity',
      created: 'Created',
      updated: 'Updated',
    },

    loading: 'Loading dashboard...',
    error: 'Failed to load dashboard',

    empty: {
      noAgents: 'No agents yet',
      noActivity: 'No recent activity',
    },
  },
};

export default dashboard;
